"use strict";
//
//
//
//
//
//
//
//
//
//
'kiwi public';

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;
var _default = {
  props: ['message', 'user', 'size'],
  computed: {
    avatar: function avatar() {
      return this.message && this.message.avatar || this.user && this.user.avatar;
    },
    firstNickLetter: function firstNickLetter() {
      return (this.message && this.message.nick || this.user && this.user.nick || '')[0];
    },
    hasAvatar: function hasAvatar() {
      return !!(this.avatar && (this.avatar.small || this.avatar.large));
    },
    avatarStyle: function avatarStyle() {
      var style = {};

      if (this.hasAvatar) {
        var url = this.size === 'small' && this.avatar.small ? this.avatar.small : this.avatar.large;
        style['background-image'] = "url(\"".concat(url, "\")");
      } else {
        style['background-color'] = "".concat(this.colour);
      }

      return style;
    },
    colour: function colour() {
      var user = this.message && this.message.user || this.user;
      return user.getColour();
    }
  }
};
exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["Avatar"]
window._kiwi_exports.components.Avatar = exports.default ? exports.default : exports;
